import { render, staticRenderFns } from "./LocationMeta.vue?vue&type=template&id=3008133c&scoped=true&"
import script from "./LocationMeta.vue?vue&type=script&lang=js&"
export * from "./LocationMeta.vue?vue&type=script&lang=js&"
import style0 from "./LocationMeta.vue?vue&type=style&index=0&id=3008133c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008133c",
  null
  
)

export default component.exports